import React from 'react';
import PropTypes from 'prop-types';
import { flowRight as compose } from 'lodash';
import withStyles from 'isomorphic-style-loader/withStyles';

import UserReviewsForm from '../../../components/siteadmin/UserReviewsForm';
import Loader from '../../../components/Loader';

// Query
import editAdminReviewsQuery from './editUserReview.graphql';
import { withQuery } from '../../../hoc/withGraphql';

import s from './UserEditReviews.css';

const UserEditReviews = (props) => {

    const { data: { loading, editUserReviews }, title, reviewId } = props;

    if (loading) {
        return (
            <Loader type={"text"} />
        );
    } else {
        return (
            <UserReviewsForm title={title} initialValues={editUserReviews} />
        );
    }
}

UserEditReviews.propTypes = {
    title: PropTypes.string.isRequired,
    reviewId: PropTypes.number.isRequired
};

UserEditReviews.defaultProps = {
    data: {
        loading: true
    }
};

export default compose(
    withStyles(s),
    withQuery(editAdminReviewsQuery,
        {
            options: (props) => ({
                variables: {
                    reviewId: props.reviewId,
                },
                fetchPolicy: 'network-only',
                ssr: false
            })
        }
    )
)(UserEditReviews);